"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DiagramNextSolid: function() {
        return DiagramNextSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const DiagramNextSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M1 4C1 2.89543 1.89543 2 3 2H21C22.1046 2 23 2.89543 23 4V8C23 9.10457 22.1046 10 21 10H13V14.5858L13.2929 14.2929C13.6834 13.9024 14.3166 13.9024 14.7071 14.2929C15.0976 14.6834 15.0976 15.3166 14.7071 15.7071L12.7071 17.7071C12.3166 18.0976 11.6834 18.0976 11.2929 17.7071L9.29289 15.7071C8.90237 15.3166 8.90237 14.6834 9.29289 14.2929C9.68342 13.9024 10.3166 13.9024 10.7071 14.2929L11 14.5858V10H3C1.89543 10 1 9.10457 1 8V4ZM21 8H3V4H21V8Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M14.1213 19.1213L16.1213 17.1213C16.9654 16.2772 17.2013 15.0553 16.8292 14H21C22.1046 14 23 14.8954 23 16V20C23 21.1046 22.1046 22 21 22H3C1.89543 22 1 21.1046 1 20V16C1 14.8954 1.89543 14 3 14H7.17083C6.79865 15.0553 7.0346 16.2772 7.87868 17.1213L9.87868 19.1213C11.0503 20.2929 12.9497 20.2929 14.1213 19.1213Z",
            fill: "currentColor"
        })
    ]
}), "DiagramNextSolid");
const _default = DiagramNextSolid;
